import { parseISO, getDay, format, setHours, setMinutes, parse } from "date-fns";
import { ServiceTimesResponse } from "../../../../api/useServiceTimes";
import {
    NFB_SERVICE,
    PSY_SERVICE,
    FIRST_EEG_SERVICE,
    GENERAL_EEG_SERVICE,
    FOLLOWUP_SERVICE,
    REPORTS_FIRST_SERVICE,
    REPORTS_SERVICE,
} from "../../../../utils/constants";

export const CUSTOM_HANDLED_FIELDS = ["start_date", "end_date", "service"];
export const DEFAULT_TIME = { hours: 10, minutes: 0 };
const OPENING_HOUR = 9;
const CLOSING_HOUR = 21;

export const toDate = (value: Date | string | null | undefined): Date | null => {
    if (!value) return null;
    const result = typeof value === "string" ? parseISO(value) : new Date(value);
    return result;
};

export const generateDefaultTimeOptions = () => {
    const hoursCount = CLOSING_HOUR - OPENING_HOUR + 1;
    const options = Array.from({ length: hoursCount }, (_, i) => i + OPENING_HOUR).flatMap((hour) =>
        ["00", "15", "30", "45"].map((minute) => `${hour.toString().padStart(2, "0")}:${minute}`),
    );
    return options;
};

export const getAllowedTimesForService = (
    serviceId: number | null,
    date: Date,
    serviceTimesData: ServiceTimesResponse | undefined,
): Array<string> | null => {
    if (!serviceId || !serviceTimesData) return null;

    const isSaturday = getDay(date) === 6;

    if (serviceId === NFB_SERVICE) {
        const times = isSaturday ? serviceTimesData.nfbAllowedTimesSaturdayNew : serviceTimesData.nfbAllowedTimesWeekNew;
        return times;
    }
    if (serviceId === PSY_SERVICE) {
        return serviceTimesData.psyAllowedTimes;
    }
    if (serviceId === FIRST_EEG_SERVICE || serviceId === GENERAL_EEG_SERVICE) {
        const eegTimes = isSaturday ? serviceTimesData.eegAllowedTimesSaturday : serviceTimesData.eegAllowedTimesWeek;
        return eegTimes;
    }
    if (serviceId === REPORTS_FIRST_SERVICE || serviceId === REPORTS_SERVICE) {
        return serviceTimesData.reportsAllowedTimes;
    }
    if (serviceId === FOLLOWUP_SERVICE) {
        return serviceTimesData.feedbackMeetingAllowedTimes;
    }
    return null;
};

export const extractTimeFromDate = (dateValue: Date | string | null | undefined): string => {
    const date = toDate(dateValue);
    if (!date) return "";
    const timeString = format(date, "HH:mm");
    return timeString;
};

export const formatDateTimeDisplay = (value: Date | string | null) => {
    const date = toDate(value);
    if (!date) return "";
    const formattedDate = format(date, "dd/MM/yyyy HH:mm");
    return formattedDate;
};

export const buildTimeOptions = (allowedTimes: Array<string> | null, currentTime: string) => {
    const baseOptions = allowedTimes ? [...allowedTimes] : generateDefaultTimeOptions();
    if (currentTime && !baseOptions.includes(currentTime)) {
        baseOptions.push(currentTime);
        baseOptions.sort();
    }
    return baseOptions;
};

export const isTimeValid = (allowedTimes: Array<string> | null, currentTime: string) => {
    if (!allowedTimes || !currentTime) return true;
    const isValid = allowedTimes.includes(currentTime);
    return isValid;
};

export const combineDateAndTime = (date: Date, hours: number, minutes: number) => {
    const combined = setMinutes(setHours(date, hours), minutes);
    return combined;
};

export const parseTimeString = (timeString: string) => {
    const [hours, minutes] = timeString.split(":").map(Number);
    return { hours, minutes };
};

export const parseStartDateParam = (paramValue: string) => {
    const parsedDate = parse(paramValue, "yyyy-MM-dd HH:mm", new Date());
    return parsedDate;
};

export const getServiceMaxDuration = (serviceId: number | null, servicesItems: Array<any> | undefined) => {
    if (!serviceId || !servicesItems) return null;
    const serviceData = servicesItems.find((s: any) => s.id === serviceId);
    const maxDuration = serviceData?.max_duration || null;
    return maxDuration;
};
